

import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  Table,
  Form,
  Row,
  Col,
  Badge,
  Dropdown,
} from "react-bootstrap";
import { FiEdit, FiSearch, FiCalendar } from "react-icons/fi";
import EditAttendanceModal from "../../../components/modals/hrm/employee/attendance/adminattendance/EditAttendanceModal";
import {  FiChevronDown } from "react-icons/fi";
import AdminAttendanceHeader from "../../../components/hrm/attendance/attendance-admin/AdminAttendanceHeader";
import AttendanceDetails from "../../../components/hrm/attendance/attendance-admin/AttendanceDetails";
const initialData = [
  {
    name: "Anthony Lewis",
    role: "UI/UX Team",
    status: "Present",
    checkIn: "09:00 AM",
    checkOut: "06:45 PM",
    break: "30 Min",
    late: "32 Min",
    hours: "8.55 Hrs",
    img: "/assets/img/users/user-49.jpg",
  },
  {
    name: "Brian Villalobos",
    role: "Development",
    status: "Present",
    checkIn: "09:00 AM",
    checkOut: "06:12 PM",
    break: "20 Min",
    late: "20 Min",
    hours: "7.54 Hrs",
    img: "/assets/img/users/user-09.jpg",
  },
  {
    name: "Lori Broaddus",
    role: "Finance",
    status: "Absent",
    checkIn: "-",
    checkOut: "-",
    break: "-",
    late: "-",
    hours: "0.00 Hrs",
    img: "/assets/img/users/user-38.jpg",
  },
];

export default function AdminAttendance() {
  const [data] = useState(initialData);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const [showModal, setShowModal] = useState(false);

  const filteredData = data
    .filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase())
    )
    .slice(0, rows);

 const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeRange, setActiveRange] = useState("Last 7 Days");
  const containerRef = useRef();

  const rangeOptions = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range"
  ];

  // close dropdown
  useEffect(() => {
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);

  // format date
  const formatDateValue = (date) =>
    date.toLocaleDateString("en-GB");

  // generate date range text
  const generateRangeLabel = () => {
    const today = new Date();
    let start = new Date();

    switch (activeRange) {
      case "Today":
        return `${formatDateValue(today)} - ${formatDateValue(today)}`;

      case "Yesterday":
        start.setDate(today.getDate() - 1);
        return `${formatDateValue(start)} - ${formatDateValue(start)}`;

      case "Last 7 Days":
        start.setDate(today.getDate() - 7);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Last 30 Days":
        start.setDate(today.getDate() - 30);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "This Year":
        start = new Date(today.getFullYear(), 0, 1);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Next Year":
        const nextStart = new Date(today.getFullYear() + 1, 0, 1);
        const nextEnd = new Date(today.getFullYear() + 1, 11, 31);
        return `${formatDateValue(nextStart)} - ${formatDateValue(nextEnd)}`;

      default:
        return "Custom Range";
    }
  };

  // select handler
  const handleRangeChange = (item) => {
    setActiveRange(item);
    setIsMenuOpen(false);
  };

  const [sort, setSort] = useState("Last 7 Days");

 

  const sortOptions = [
    "Recently Added",
    "Ascending",
    "Descending",
    "Last Month",
    "Last 7 Days",
  ];
  return (
    <>
    <div   style={{ padding: "15px", background: "#f8f9fa",  }}
 >
<AdminAttendanceHeader/>
<AttendanceDetails/>
<Card   className="border-0 shadow-sm mt-3">
     <Card.Header
      style={{
        background: "#fff",
        padding: "16px 20px",
        borderBottom: "1px solid #eee",
      }}
      className="d-flex flex-wrap justify-content-between align-items-center"
    >
      {/* TITLE */}
      <h5
        style={{
          fontWeight: 600,
          fontSize: "16px",
          margin: 0,
        }}
      >
        Admin Attendance
      </h5>

      {/* RIGHT SIDE */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        {/* DATE RANGE */}
      <div ref={containerRef} style={{ position: "relative", }}>

      {/* TOP INPUT */}
      <div
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          border: "1px solid #e5e7eb",
          padding: "10px 12px",
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          background: "#fff",
          fontSize: 14
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FiCalendar />
          {generateRangeLabel()}
        </div>
        <FiChevronDown />
      </div>

      {/* DROPDOWN LIST */}
      {isMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            width: "80%",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "8px 0",
            zIndex: 1000
          }}
        >
          {rangeOptions.map((item, idx) => (
            <div
              key={idx}
              onClick={() => handleRangeChange(item)}
              style={{
                padding: "12px 16px",
                fontSize: 14,
                cursor: "pointer",
                background:
                  activeRange === item ? "#ff6b00" : "transparent",
                color:
                  activeRange === item ? "#fff" : "#111827"
              }}
              onMouseEnter={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "transparent";
              }}
            >
              {item}
            </div>
          ))}
        </div>
      )}

      {/* MOBILE */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style] {
              width: 100% !important;
              margin-top: 10px !important;
            }
          }
        `}
      </style>
    </div>


        {/* DEPARTMENT */}
        <Dropdown>
          <Dropdown.Toggle
            style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              color: "#333",
              fontSize: "14px",
              padding: "8px 12px",
            }}
          >
            Department <FiChevronDown size={14} />
          </Dropdown.Toggle>

          <Dropdown.Menu style={{ borderRadius: "8px" }}>
            <Dropdown.Item>Finance</Dropdown.Item>
            <Dropdown.Item>Development</Dropdown.Item>
            <Dropdown.Item>Management</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* STATUS */}
        <Dropdown>
          <Dropdown.Toggle
            style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              color: "#333",
              fontSize: "14px",
              padding: "8px 12px",
            }}
          >
            Select Status <FiChevronDown size={14} />
          </Dropdown.Toggle>

          <Dropdown.Menu style={{ borderRadius: "8px" }}>
            <Dropdown.Item>Present</Dropdown.Item>
            <Dropdown.Item>Absent</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* SORT */}
        <Dropdown>
          <Dropdown.Toggle
            style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              color: "#333",
              fontSize: "14px",
              padding: "8px 12px",
            }}
          >
            Sort By : {sort} <FiChevronDown size={14} />
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{
              borderRadius: "10px",
              padding: "6px",
              width: "180px",
            }}
          >
            {sortOptions.map((item) => (
              <div
                key={item}
                onClick={() => setSort(item)}
                style={{
                  padding: "10px",
                  borderRadius: "6px",
                  fontSize: "14px",
                  cursor: "pointer",
                  background:
                    sort === item ? "#ff6b00" : "transparent",
                  color: sort === item ? "#fff" : "#333",
                }}
              >
                {item}
              </div>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </Card.Header>

        {/* TOP BAR */}
        <div className="p-3 d-flex justify-content-between flex-wrap">
          <div>
            Row Per Page{" "}
            <Form.Select
              style={{ width: "60px", display: "inline" }}
              onChange={(e) => setRows(e.target.value)}
            >
              <option>5</option>
              <option>10</option>
              <option>20</option>
            </Form.Select>
          </div>

          <div className="input-group" style={{ maxWidth: "250px" }}>
            <span className="input-group-text">
              <FiSearch />
            </span>
            <Form.Control
              placeholder="Search"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* TABLE */}
        <Table responsive hover className="mb-0">
          <thead>
            <tr>
              <th></th>
              <th>Employee</th>
              <th>Status</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Break</th>
              <th>Late</th>
              <th>Production Hours</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {filteredData.map((item, i) => (
              <tr key={i}>
                <td>
                  <Form.Check />
                </td>

                <td>
                  <div className="d-flex align-items-center">
                    <img
                      src={item.img}
                      alt=""
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        marginRight: 10,
                      }}
                    />
                    <div>
                      <div>{item.name}</div>
                      <small className="text-muted">
                        {item.role}
                      </small>
                    </div>
                  </div>
                </td>

                <td>
                  <Badge
                    bg={item.status === "Present" ? "success" : "danger"}
                  >
                    {item.status}
                  </Badge>
                </td>

                <td>{item.checkIn}</td>
                <td>{item.checkOut}</td>
                <td>{item.break}</td>
                <td>{item.late}</td>

                <td>
                  <Badge
                    bg={
                      item.status === "Absent"
                        ? "danger"
                        : "success"
                    }
                  >
                    {item.hours}
                  </Badge>
                </td>

                <td>
                  <FiEdit
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowModal(true)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>

      {/* MODAL */}
      <EditAttendanceModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </div>
      
    </>
  );
}